export interface SignModel {
  wantsToDigitallySign: "yes" | "no";
  acceptTermsAndConditions: boolean;
}

export enum RejectionReason {
  NO_DATA_MATCH = "NO_DATA_MATCH",
  NEGATIVE_PROFILING = "NEGATIVE_PROFILING",
  FALSE_BIRTHDATE = "FALSE_BIRTHDATE",
  MANIPULATIVE_TRY = "MANIPULATIVE_TRY",
  FALSE_PERS_ATTRIBUTES = "FALSE_PERS_ATTRIBUTES",
  FRAUD_DOCUMENT = "FRAUD_DOCUMENT",
  MACHINE_READABLE_ZONE_CHECK_DIGIT_ERROR = "MACHINE_READABLE_ZONE_CHECK_DIGIT_ERROR",
  DIFFERING_AGE = "DIFFERING_AGE",
  AGAIN = "AGAIN",
  NO_DATA_MATCH_AND_MANIPULATIVE_TRY = "NO_DATA_MATCH_AND_MANIPULATIVE_TRY",
  NO_DATA_MATCH_AND_FALSE_PERS_ATTRIBUTES = "NO_DATA_MATCH_AND_FALSE_PERS_ATTRIBUTES",
  NO_DATA_MATCH_AND_NEGATIVE_PROFILING = "NO_DATA_MATCH_AND_NEGATIVE_PROFILING",
  NO_DATA_MATCH_AND_FALSE_BIRTHDATE = "NO_DATA_MATCH_AND_FALSE_BIRTHDATE",
  NATIONALITY_NOT_SUPPORTED = "NATIONALITY_NOT_SUPPORTED",
  IDENTIFICATION_REJECTED = "IDENTIFICATION_REJECTED",
  SIGNING_REJECTED = "SIGNING_REJECTED",
}
